import { useField } from "formik";
import React from "react";
import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const FormikListItemCheckbox = ({
  name,
  primary,
  secondary,
  dense = false,
  disablePadding = false,
  ...props
}) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  const [field, meta, helpers] = useField(name);

  const labelId = `checkbox-list-label-${name}`;

  const handleToggle = () => {
    if (props.onChange) {
      props.onChange(!field.value);
    }
    helpers.setValue(!field.value);
  };

  return (
    <ListItem disablePadding={disablePadding}>
      <ListItemButton
        role={undefined}
        onClick={handleToggle}
        dense={dense}
        {...props}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={field.value || false}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": labelId }}
          />
        </ListItemIcon>
        <ListItemText id={labelId} primary={primary} secondary={secondary} />
      </ListItemButton>
    </ListItem>
  );
};

export default FormikListItemCheckbox;
